/*
 * From https://www.redblobgames.com/maps/terrain-from-noise/
 * Copyright 2022 Red Blob Games <redblobgames@gmail.com>
 * License: Apache-2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>
 */

/** Show before/after values of elevation or moisture */
export default class SvgRemappingChart {
    step: number;
    digits: number;
    svg: SVGSVGElement;
    path: SVGPathElement;
    
    constructor(selector : SVGSVGElement | string, options: {step?: number, digits?: number, prefixSvg?: string} = {}) {
        this.step = options.step ?? 0.01;
        this.digits = options.digits ?? 3;
        
        this.svg = typeof selector === 'string'? document.querySelector(selector) : selector;
        this.svg.setAttribute('viewBox', "-0.11 -0.01 1.12 1.12");
        this.svg.innerHTML += `
        ${options.prefixSvg ?? ""}
        <path fill="none"  stroke="#ccc" stroke-width="0.007" d="M 0,0 l 0,1 l 1,0 M 0,1 l 1,-1"/>
        <g fill="#999" font-size="0.1" text-anchor="middle" transform="translate(0,1)">
          <text x="0.03" y="0.1">0</text>
          <text x="0.97" y="0.1">1</text>
          <text x="0.5" y="0.1">Before</text>
          <g transform="rotate(-90) translate(0,-0.02)">
            <text x="0.03" y="0">0</text>
            <text x="0.97" y="0">1</text>
            <text x="0.5" y="0">After</text>
          </g>
        </g>
        <path fill="none" stroke="#a44" stroke-width="0.02" stroke-linecap="round" transform="translate(0,1), scale(1,-1)" d=""/>`;
        this.path = this.svg.querySelector("path[d='']");
    }

    setFn(remapFn: (e: number) => number) {
        const {step, digits} = this;
        let points = [];
        for (let e = 0; e <= 1; e += step) {
            points.push(`${e.toFixed(digits)},${remapFn(e).toFixed(digits)}`);
        }
        let d = "M " + points.join(" L ");
        this.path.setAttribute('d', d);
    }
}    
